<template>
  <lu-hbox lu-vcenter lu-hcenter class='pad-in-5 riskSettingTotal' >
    <lu-item>{{ $t('Total') }} </lu-item>
    <lu-item :class='dataExposureTotal.profitAndLoss >= 0 ? "positive" : "negative"'>{{ dataExposureTotal.profitAndLoss | formatAmount }}</lu-item>
  </lu-hbox>
</template>

<script>
import { LuHbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'

export default {
  name: 'SettingsTotal',
  components: { LuHbox, LuItem },
  props: ['dataExposureTotal'],
  filters: {
    formatAmount: function (value) {
      return value ? utils.formatAmount(value, 2, 3) : ''
    }
  }
}
</script>

<style lang='scss'>

.riskSettingTotal {
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 1.4em;
}
</style>